import {AssertUtils} from 'goingutils';

export default {
    name: "go-btn-mixins",
    data(){
        let _btnItemObj={};
        //如果btnItem不为空 则表示传入的是对象
        if(AssertUtils.isNotNull(this.btnItem)){
            for(let propName in this.$props){
                if(propName!=="btnItem"){
                    this.setPropValue(this.btnItem,propName,this.$props[propName]);
                }
            }
            _btnItemObj={...this.btnItem};
        }else{
            for(let propName in this.$props){
                this.setPropValue(_btnItemObj,propName,this.$props[propName]);
            }
        }
        if(AssertUtils.isNotEmpty(_btnItemObj.label)){
            _btnItemObj["text"]=_btnItemObj.label;
        }
        return {
            buttonSize:this.btnSize,
            btnItemObj:_btnItemObj
        };
    },
    computed: {
        //显示标志
        showFlag(){
            return this.btnItemObj.show;
        },
        //不可以点击的标志
        btnDisabled(){
            return this.btnItemObj.disabled;
        },
    },
    props: {
        //按钮大小，可选值为large、small、default或者不设置
        btnSize: {
            type: String,
            default: 'small'
        },
        //按钮是否显示
        show: {
            type: Boolean,
            default: true
        },
        //按钮的类型 分submit 和 common 2种类型
        type: {
        },
        //按钮对象
        btnItem: {
            type: Object,
            default: null
        },
        //按钮的宽度
        width: {
            type: [String, Number],
            default: ""
        },
        //按钮的label
        label: {
            type: String,
            default: null
        },
        //按钮的图标
        img: {},
        //按钮的样式信息
        className: {
            type: String,
            default: ""
        },
        //按钮是否可以点击
        disabled: {
            type: Boolean,
            default: false
        },
        //按钮的id
        id: {},
        //按钮加载中
        loading: {
            type: Boolean,
            default: false
        },
        //是否为圆角按钮
        circle: {
            type: Boolean,
            default: true
        },
    },
    methods: {
        //设置参数值
        setPropValue(itemObj, propName, propValue) {
            if(itemObj==null){
                return void(0);
            }
            //如果对象属性存在 而且对象属性的值跟传入的值不一样
            if (itemObj[propName] != null&&AssertUtils.isNotNull(propValue)&&itemObj[propName]!==propValue) {
                itemObj[propName] = propValue;
            } else if(itemObj[propName] == null&&AssertUtils.isNotNull(propValue)){
                //如果对象属性不存在 则需要通过set来设置
                this.$set(itemObj, propName, propValue);
            }
        },

        //获取是否可以点击的样式
        getDisabledClass(disabled) {
            if (disabled) {
                return " disabled";
            } else {
                return "";
            }
        },
        //点击按钮事件 并触发父节点传入的事件
        btnClick($event){
            let disabledDom=$($event.target)&&$($event.target).attr("disabled");

            let {loading,disabled,id}=this.btnItemObj;
            if (loading) {
                return void (0);
            }
            //防止jquery操作的dom 让按钮不可以点击
            if(disabledDom==='disabled'){
                return void (0);
            }
            //如果是disabled则不
            if (!disabled) {
                this.$emit("click", id);
                this.$emit("btnClick", id);
            }
        }
    },
    mounted() {
    },
    components: {},
    watch:{
        show(newVal){
            if(this.btnItemObj.show!=newVal){
                this.btnItemObj.show=newVal;
            }
        },
        //监听按钮的可以点击不可以点击的变化
        disabled(newVal){
            if(this.btnItemObj.disabled!=newVal){
                this.btnItemObj.disabled=newVal;
            }
        }
    }
};



// WEBPACK FOOTER //
// ./goingsrc/vueCom/ctlVue/go-tool-bar/mixins/btnMixin.js